export default __webpack_public_path__ + "static/media/partners1.5968bc08.png";